// extracted by mini-css-extract-plugin
export var downArrow = "_iu-0";
export var infoTooltipIcon = "_iu-3";
export var label = "_iu-1";
export var optionCard = "_iu-4";
export var upArrow = "_iu-2";